/**
 * @generated SignedSource<<ee5d3de920d057bd710d7bb71f058b4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HubTemplateEnum = "HOME_LANDING_PAGE" | "HUB_TEMPLATE_03" | "SALES_LANDING_PAGE";
export type ZnglyContext_TopBarNavigation_Query$variables = Record<PropertyKey, never>;
export type ZnglyContext_TopBarNavigation_Query$data = {
  readonly hubs: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly postOrder: number | null | undefined;
        readonly slug: string | null | undefined;
        readonly template: HubTemplateEnum | null | undefined;
        readonly title: string;
      };
    }>;
  } | null | undefined;
  readonly znglists: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly slug: string | null | undefined;
        readonly title: string | null | undefined;
        readonly znglist: {
          readonly order: number | null | undefined;
        } | null | undefined;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Category_Fragment">;
};
export type ZnglyContext_TopBarNavigation_Query = {
  response: ZnglyContext_TopBarNavigation_Query$data;
  variables: ZnglyContext_TopBarNavigation_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v1 = [
  (v0/*: any*/),
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "order": "ASC",
      "orderBy": [
        "PostOrder"
      ],
      "status": "PUBLISH"
    }
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "template",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postOrder",
  "storageKey": null
},
v6 = [
  (v0/*: any*/),
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "status": "PUBLISH"
    }
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Znglist_Znglist",
  "kind": "LinkedField",
  "name": "znglist",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  (v0/*: any*/),
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "childless": false,
      "hierarchical": true,
      "parent": null
    }
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Category_Znglycategory",
  "kind": "LinkedField",
  "name": "znglycategory",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uxOrder",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pinnedContent",
      "plural": true,
      "selections": [
        (v12/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v9/*: any*/),
            (v3/*: any*/)
          ],
          "type": "ZnglyVideo",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v9/*: any*/)
          ],
          "type": "Node",
          "abstractKey": "__isNode"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ZnglyContext_TopBarNavigation_Query",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Category_Fragment"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RootQueryToHubConnection",
        "kind": "LinkedField",
        "name": "hubs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToHubConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Hub",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "hubs(first:1000,where:{\"order\":\"ASC\",\"orderBy\":[\"PostOrder\"],\"status\":\"PUBLISH\"})"
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "RootQueryToZnglistConnection",
        "kind": "LinkedField",
        "name": "znglists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToZnglistConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Znglist",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "znglists(first:1000,where:{\"status\":\"PUBLISH\"})"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ZnglyContext_TopBarNavigation_Query",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "RootQueryToCategoryConnection",
        "kind": "LinkedField",
        "name": "categories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToCategoryConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Category",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      (v0/*: any*/)
                    ],
                    "concreteType": "CategoryToCategoryConnection",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CategoryToCategoryConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": "children(first:1000)"
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToCategoryConnectionPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": "categories(first:1000,where:{\"childless\":false,\"hierarchical\":true,\"parent\":null})"
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "filters": [
          "where"
        ],
        "handle": "connection",
        "key": "CategoriesComponent_query__categories",
        "kind": "LinkedHandle",
        "name": "categories"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RootQueryToHubConnection",
        "kind": "LinkedField",
        "name": "hubs",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToHubConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Hub",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "hubs(first:1000,where:{\"order\":\"ASC\",\"orderBy\":[\"PostOrder\"],\"status\":\"PUBLISH\"})"
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "RootQueryToZnglistConnection",
        "kind": "LinkedField",
        "name": "znglists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RootQueryToZnglistConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Znglist",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "znglists(first:1000,where:{\"status\":\"PUBLISH\"})"
      }
    ]
  },
  "params": {
    "cacheID": "459c0ee135180c4dcd2283e8f6ac77da",
    "id": null,
    "metadata": {},
    "name": "ZnglyContext_TopBarNavigation_Query",
    "operationKind": "query",
    "text": "query ZnglyContext_TopBarNavigation_Query {\n  ...Category_Fragment\n  hubs(first: 1000, where: {status: PUBLISH, order: ASC, orderBy: [PostOrder]}) {\n    edges {\n      node {\n        slug\n        title\n        template\n        postOrder\n        id\n      }\n    }\n  }\n  znglists(first: 1000, where: {status: PUBLISH}) {\n    edges {\n      node {\n        slug\n        title\n        znglist {\n          order\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Category_Fragment on RootQuery {\n  categories(first: 1000, where: {childless: false, hierarchical: true, parent: null}) {\n    edges {\n      node {\n        id\n        name\n        count\n        znglycategory {\n          uxOrder\n          pinnedContent {\n            __typename\n            ... on ZnglyVideo {\n              id\n              title\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n        children(first: 1000) {\n          edges {\n            node {\n              id\n              name\n              count\n              znglycategory {\n                uxOrder\n                pinnedContent {\n                  __typename\n                  ... on ZnglyVideo {\n                    id\n                    title\n                  }\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d27f795a24773406cabf8d09877970fe";

export default node;
